export enum BluViuNutritionTab {
  SCENARIOS = 'scenarios',
  CALIBRATIONS = 'calibrations',
  MULTICAGESCENARIO = 'r2',
}

export interface BluViuNutritionParams {
  tab: BluViuNutritionTab; // scenarios or calibrations
  // siteErpId: string; // temporarily disabled because some sites belonging to Chilean customers do not have address numbers
  globalSiteId: string;
}
